import { render, staticRenderFns } from "./UploadsTable.vue?vue&type=template&id=2268a94c&"
import script from "./UploadsTable.vue?vue&type=script&lang=js&"
export * from "./UploadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports